// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__ai-modal .cz2__ai-modal__selfie-say-cheese{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:24px;background-color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
